export const STAGES = [
  "New",
  "Junk",
  "Not Connected",
  "Follow-up",
  "Interested",
  "Not-Interested",
  "Contact-in-Future",
  "Agreement In-Process",
  "Onboarding-in-Process",
  "Live",
];

export const STAGES_REQUIRING_TAG = new Set([
  "Follow-up",
  "Interested",
  "Agreement In-Process",
  "Onboarding-in-Process",
]);

export const TAGS = ["Hot", "Warm", "Cold", "Lost"];

// Metadata for every mandatory field that can be requested during a stage transition.
// `type` drives the inline editor in StageTransitionDialog.
export const SELLER_TAG_OPTIONS = [
  { value: 1, label: "Brand" },
  { value: 2, label: "Magic" },
  { value: 3, label: "Drop-Shipper" },
  { value: 4, label: "Trader" },
  { value: 5, label: "Aggregator" },
];

export const FIELD_META = {
  lead_source: { label: "Lead Source", type: "master", masterKey: "lead_source" },
  sales_poc: { label: "Pipeline", type: "master", masterKey: "sales_poc" },
  company_name: { label: "Company Name", type: "text" },
  website_url: { label: "Website URL", type: "text", placeholder: "https://" },
  client_poc_name: { label: "Client POC Name", type: "text" },
  poc_designation: { label: "POC Designation", type: "text" },
  category: { label: "Category", type: "master", masterKey: "category" },
  client_type: { label: "Client Type", type: "master", masterKey: "client_type" },
  remarks: { label: "Remarks", type: "textarea" },
  opportunity_type: { label: "Opportunity Type", type: "multimaster", masterKey: "opp_type" },
  warehouse_location: { label: "Warehouse Location", type: "text" },
  hq_city: { label: "HQ City", type: "text" },
  hq_state: { label: "HQ State", type: "master", masterKey: "state" },
  current_wh_partner: { label: "Current WH Partner", type: "master", masterKey: "wh_partner" },
  current_lm_partner: { label: "Current LM Partner", type: "master", masterKey: "lm_partner" },
  wms_oms: { label: "WMS/OMS", type: "master", masterKey: "wms_oms" },
  monthly_order_potential: { label: "Monthly Order Potential", type: "number" },
  overall_monthly_revenue: { label: "Overall Monthly Revenue (Potential)", type: "number" },
  universal_order_potential: { label: "Universal Order Potential (B2C & D2C)", type: "number" },
  mg_amount: { label: "MG Amount", type: "number" },
  interested_month: { label: "Interested Month", type: "month" },
  tentative_live_month: { label: "Tentative Live Month", type: "month" },
  agreement_initiated_month: { label: "Agreement Initiated Month", type: "month" },
  oib_month: { label: "OIB Month", type: "month" },
  live_month: { label: "Live Month", type: "month" },
  lost_reason: { label: "Lost / Not Int Reason", type: "master", masterKey: "lost_reason" },
  seller_tag: { label: "Seller Tag", type: "sellertag" },
};
